// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListElementComponent } from './components/list-element/list-element.component';
import { ProgressBarModule } from '@coa/app/shared/progress-bar/progress-bar.module';
import { DateRangeLabelModule } from '@coa/app/shared/date-range-label/date-range-label.module';
import { SimpleLineChartModule } from '@coa/app/shared/simple-line-chart/simple-line-chart.module';
import { ListElementSkeletonComponent } from './skeletons/list-element-skeleton/list-element-skeleton.component';
import { PercentageChangeModule } from '@coa/app/shared/percentage-change/percentage-change.module';
import { ListErrorComponent } from '@coa/app/shared/list/components/list-error/list-error.component';
import { TranslateModule } from '@ngx-translate/core';
import { ListNoDataComponent } from '@coa/app/shared/list/components/list-no-data/list-no-data.component';
import { MatIconModule } from '@angular/material/icon';
import { FeatureToggleModule } from '@coa/app/shared/feature-toggle/feature-toggle.module';
import { IconTooltipModule } from '@coa/app/shared/icon-tooltip/icon-tooltip.module';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    ListElementComponent,
    ListElementSkeletonComponent,
    ListErrorComponent,
    ListNoDataComponent,
  ],
  imports: [
    CommonModule,
    ProgressBarModule,
    DateRangeLabelModule,
    SimpleLineChartModule,
    PercentageChangeModule,
    TranslateModule.forChild(),
    MatIconModule,
    FeatureToggleModule,
    IconTooltipModule,
    MatTooltipModule,
  ],
  exports: [
    ListElementComponent,
    ListElementSkeletonComponent,
    ListErrorComponent,
    ListNoDataComponent,
  ],
})
export class ListModule {
}
